import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useWbNavBlock = ({ onRestoreNav }) => {
  const blockingNavigation = useSelector(
    (state) => state.application.blockingNavigation,
  );
  useEffect(() => {
    const restoreNav =
      blockingNavigation.isBlocking && blockingNavigation.shouldRevalidateNav;

    if (restoreNav) {
      onRestoreNav();
    }
  }, [blockingNavigation, onRestoreNav]);

  return {
    blockingNavigation,
  };
};
